"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.PerPageBlock = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
exports.Container = styled_components_1.default.div `
  width: 100%;
  margin-top: ${props => props.theme.spacing.m3}px;
  display: flex;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;
exports.PerPageBlock = styled_components_1.default.div `
  display: flex;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-top: ${props => props.theme.spacing.m3}px;
  }
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.medium};
  color: ${props => props.theme.palette.LIGHT_BLACK};
  margin-right: ${props => props.theme.spacing.s3}px;
`;
exports.default = {
    Container: exports.Container,
    PerPageBlock: exports.PerPageBlock,
    Title: exports.Title
};
